import { Navigate } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';
import { landingFor } from '@/lib/landing';

/**
 * The index route. It used to redirect everyone to `/anatel/overview`, so an
 * account licensed for CADE alone signed in to a 403 on a screen it cannot open.
 */
export function HomeRedirect() {
  const { mayAccess } = useAuth();
  return <Navigate to={landingFor(mayAccess)} replace />;
}
